module.exports = __webpack_public_path__ + "static/pic02-587752de773d4a7eb272d74d34b83996.jpg";